import {Avatar, Button, Typography} from "@material-tailwind/react";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import Dict from "../../../helper/dict";
import React, {useContext, useState} from "react";
import {getFileUrl} from "../../../config";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = ["#", "کاربر", "پروفایل", "نقش", "وضعیت", "پیام‌ها"];

export function UserNotificationReportGrid({
                                             userReport,
                                             setSelectedRow,
                                             setModalOpen,
                                           }) {
  const avatar = '/assets/default_avatar.avif';

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "name",
    "پروفایل": "photo",
    "نقش": "role",
    "وضعیت": "status",
    "پیام‌ها": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "پروفایل": false,
    "نقش": true,
    "وضعیت": true,
    "پیام‌ها": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {userReport.map(
          ({id, name, photo, role, phone, balance, status}, index) => {
            const isLast = index === userReport.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  {photo.length > 0 &&
                    <Avatar variant="circular" alt="tania andrew"
                            className="cursor-pointer border-white"
                            withBorder={true} size="sm"
                            src={getFileUrl(photo)}
                    />
                  }
                  {photo.length === 0 &&
                    <Avatar variant="circular" alt="tania andrew"
                            className="cursor-pointer border-white"
                            withBorder={true} size="sm"
                            src={avatar}
                    />
                  }
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {Dict(role)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Button variant="outlined" onClick={() => {
                    setSelectedRow(id);
                    setModalOpen(true);
                  }}
                  >
                    مشاهده پیام‌ها
                  </Button>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}